// src/hooks/useUser.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from "services/firebaseConfig";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userProfile, setUserProfile] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    const authUnsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userDocRef = doc(db, "users", user.uid);

        const firestoreUnsubscribe = onSnapshot(
          userDocRef,
          (docSnapshot) => {
            if (docSnapshot.exists()) {
              setUserProfile(docSnapshot.data());
            } else {
              setUserProfile(null);
            }
            setLoadingUser(false);
          },
          (error) => {
            console.error("Erro ao buscar perfil do usuário:", error);
            setUserProfile(null);
            setLoadingUser(false);
          },
        );

        return () => firestoreUnsubscribe();
      } else {
        setUserProfile(null);
        setLoadingUser(false);
      }
    });

    return () => authUnsubscribe();
  }, []);

  const defaultPermissions = {
    canViewExcursions: true,
    canViewChales: true,
    canViewDashboard: false,
  };

  const permissions = userProfile
    ? { ...defaultPermissions, ...userProfile.permissions }
    : {
        canViewExcursions: false,
        canViewChales: false,
        canViewDashboard: false,
      };

  const value = {
    userProfile,
    role: userProfile?.role,
    isLoadingUser: loadingUser,
    isAdmin: userProfile?.role === "admin",
    isEditor: userProfile?.role === "editor",
    isViewer: userProfile?.role === "viewer",
    isPending: userProfile?.role === "pending",

    canViewExcursions: permissions.canViewExcursions,
    canViewChales: permissions.canViewChales,
    canViewDashboard: permissions.canViewDashboard,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser deve ser usado dentro de um UserProvider");
  }
  return context;
};
